/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-use-before-define */

import { createRoot } from 'react-dom/client';

import { router, themeConfig } from '@components';
import { SharedSpinner } from '@components';
import { AbpUserConfigurationService } from '@services';
import { StoreContext, stores } from '@stores';
import { Utils } from '@utils';

import Hotjar from '@hotjar/browser';
import { AppConsts } from '@lib';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';

import { ConfigProvider } from 'antd';
import { ClarityService } from '@services';
import './ios-design-fixes.css';
import './form-controls.css';


dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(updateLocale);
// Weeks start on Monday everywhere dayjs is asked (startOf('week') behind the side panel's
// "this week" and the inventory presets), matching the calendar's firstDay={1}. The default
// 'en' locale starts on Sunday, which put those presets a day out from the week on screen.
dayjs.updateLocale('en', { weekStart: 1 });

declare const abp: any;

Utils.setLocalization();

AbpUserConfigurationService.getAll().then((data) => {
  Utils.extend(true, abp, data.data.result);
  abp.clock.provider = Utils.getCurrentClockProvider(data.data.result.clock.provider);

  dayjs.locale(abp.localization.currentLanguage.name);
  dayjs.tz.setDefault(dayjs.tz.guess());

  const container = document.getElementById('root') as HTMLElement;
  const root = createRoot(container);

  Hotjar.init(AppConsts.hotjarSiteId, AppConsts.hotjarVersion);

  ClarityService.init(AppConsts.clarityProjectId);

  const spinner = document.getElementById('loading-spinner');
  if (spinner) {
    spinner.style.display = 'none';
  }

  root.render(
    <ConfigProvider theme={themeConfig}>
      <StoreContext.Provider value={stores}>
        <Suspense fallback={<SharedSpinner loading />}>
          <RouterProvider router={router} />
        </Suspense>
      </StoreContext.Provider>
    </ConfigProvider>
  );

});
